import React from 'react';
import '../template-file-css/document-file-template.css';


export const GFIT_SafetyPlan = ({ itemsRef, howErrorFor, }) => {

    return (
        <form id='GFIT_SafetyPlan' className='file-pdf-document'>
            <div className='file-template'>

                <h2><center> SAFETY/CRISIS SAFETY PLAN</center></h2>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Step 1: Warning signs:</span> </td>
                    </tr>
                    <ol>
                        <tr>
                            <li> <td className='w-700'> <input id='txtWarningsigns_1' name='txtWarningsigns_1' type='text' className='add-only' /> </td></li>
                        </tr>
                        <tr>
                            <li><td className='w-700'> <input id='txtWarningsigns_2' name='txtWarningsigns_2' type='text' className='add-only' /> </td></li>
                        </tr>
                        <tr>
                            <li> <td className='w-700'> <input id='txtWarningsigns_3' name='txtWarningsigns_3' type='text' className='add-only' /> </td></li>
                        </tr>
                    </ol>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Step 2: Internal coping strategies - Things I can do to take my mind off my problems without contacting another person:</span> </td>
                    </tr>
                    <ol>
                        <tr>
                            <li> <td className='w-700'> <input id='txtstrategies_1' name='txtstrategies_1' type='text' className='add-only' /> </td></li>
                        </tr>
                        <tr>
                            <li> <td className='w-700'> <input id='txstrategies_2' name='txtstrategies_2' type='text' className='add-only' /> </td></li>
                        </tr>
                        <tr>
                            <li> <td className='w-700'> <input id='txtstrategies_3' name='txtstrategies_3' type='text' className='add-only' /> </td></li>
                        </tr>
                    </ol>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Step 3: People and social settings that provide distraction:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> 1.Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> 1.Phone number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName1_1' name='txtName1_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhonenumber1_1' name='txtPhonenumber1_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> 2.Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> 2.Phone number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName1_2' name='txtName1_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhonenumber1_2' name='txtPhonenumber1_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Place:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPlace_1' name='txtPlace_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Place:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtPlace_2' name='txtPlace_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Step 4: People whom I can ask for help:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> 1.Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> 1.Phone number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName2_1' name='txtName2_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhonenumber2_1' name='txtPhonenumber2_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> 2.Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> 2.Phone number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName2_2' name='txtName2_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhonenumber2_2' name='txtPhonenumber2_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> 3.Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> 3.Phone number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName2_3' name='txtName2_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhonenumber2_3' name='txtPhonenumber2_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Step 5: Professionals or agencies I can contact during a crisis:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Clinician Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Phone number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClinician' name='txtClinician' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhoneNo_1' name='txtPhoneNo_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Clinician Pager or Emergency Contact #</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtEmergencyContact' name='txtEmergencyContact' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Clinician Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Phone number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> Leisha Benjamin	Phone number:</td>
                        <td className='w-375'> 678-951-0632</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Clinician Pager or Emergency Contact #</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> 678-951-0632 </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> 988 Suicide & Crisis Lifeline:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Emergency Services:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  988 (call or text)	988lifeline.org </td>
                        <td className='w-375'>  911 </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Suicide Prevention Lifeline:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> GA Crisis & Access Hotline:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  1-800-273-TALK (8255) </td>
                        <td className='w-375'> 1-800-715-4225  </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Local Emergency Service:</span> </td>
                        <td className='w-375'> <span className='eleHeader'> Phone number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtLocalEmergencyService' name='txtLocalEmergencyService' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhoneNo_2' name='txtPhoneNo_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtAddress' name='txtAddress' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Making the environment safe:</span> </td>
                    </tr>
                    <ol>
                        <tr>
                            <li>  <td className='w-700'> <input id='txtenvironment_1' name='txtenvironment_1' type='text' className='add-only' /> </td></li>
                        </tr>
                        <tr>
                            <li> <td className='w-700'> <input id='txenvironment_2' name='txenvironment_2' type='text' className='add-only' /> </td></li>
                        </tr>
                    </ol>
                    <tr>
                        <td className='w-750'><span className='eleHeader'> Additional Crisis Prevention/Early Intervention Strategies</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_1' name='cbIntervention_1' className='add-only' value='0' /> Time out in my room</td>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_2' name='cbIntervention_2' className='add-only' value='1' /> Holding ice in my hand/Cold water on hands</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_3' name='cbIntervention_3' className='add-only' value='0' />Writing in a journal	</td>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_4' name='cbIntervention_4' className='add-only' value='1' /> A cold cloth on face</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_5' name='cbIntervention_5' className='add-only' value='0' /> Screaming into a pillow</td>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_6' name='cbIntervention_6' className='add-only' value='1' /> Taking a cold/hot shower</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_7' name='cbIntervention_7' className='add-only' value='0' /> Ripping paper</td>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_8' name='cbIntervention_8' className='add-only' value='1' />Exercising</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_9' name='cbIntervention_9' className='add-only' value='0' /> Hugging a stuffed animal</td>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_10' name='cbIntervention_10' className='add-only' value='1' /> Lying down or taking a nap</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> People trying to help me should know the following things can make it worse:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbworse_1' name='cbworse_1' className='add-only' value='0' /> Peers teasing</td>
                        <td className='w-375'><input type='checkbox' id='cbworse_2' name='cbworse_2' className='add-only' value='1' /> Being disrespected</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbworse_3' name='cbworse_3' className='add-only' value='0' /> Loud tone of voice</td>
                        <td className='w-375'><input type='checkbox' id='cbworse_4' name='cbworse_4' className='add-only' value='1' /> Being ignored</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbworse_5' name='cbworse_5' className='add-only' value='0' /> Not being listened to</td>
                        <td className='w-375'><input type='checkbox' id='cbworse_6' name='cbworse_6' className='add-only' value='1' /> Being touched</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Sometimes when I get upset, I want to hurt someone:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='radio' id='rbhurtsomeoneYes_1' name='rbhurtsomeone_1' className='add-only' value='0' /> Yes</td>
                        <td className='w-150'> <input type='radio' id='rbhurtsomeoneNo_1' name='rbhurtsomeone_1' className='add-only' value='1' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> Sometimes I feel paranoid:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='radio' id='rbparanoidYes_1' name='rbparanoid_1' className='add-only' value='0' /> Yes</td>
                        <td className='w-150'> <input type='radio' id='rbparanoidNo_1' name='rbparanoid_1' className='add-only' value='1' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'> I have previously wanted to die:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='radio' id='rbwantedtodieYes_1' name='rbwantedtodie_1' className='add-only' value='0' /> Yes</td>
                        <td className='w-150'> <input type='radio' id='rbwantedtodieNo_1' name='rbwantedtodie_1' className='add-only' value='1' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>I have previously tried to kill myself:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='radio' id='rbkillmyselfYes_1' name='rbkillmyself_1' className='add-only' value='0' /> Yes</td>
                        <td className='w-150'> <input type='radio' id='rbkillmyselfNo_1' name='rbkillmyself_1' className='add-only' value='1' /> No</td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>I have previously tried to mutilate myself (non-suicidal self-injurious behavior):</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='radio' id='rbmyselfYes_1' name='rbself_1' className='add-only' value='0' /> Yes</td>
                        <td className='w-150'> <input type='radio' id='rbmyselfNo_1' name='rbself_1' className='add-only' value='1' /> No</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If yes, how:</span>
                    <textarea id='txthow' name='txthow' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Access to Lethal Means:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_1' name='cbIntervention_1' className='add-only' value='0' /> None</td>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_2' name='cbIntervention_2' className='add-only' value='1' />Firearm access</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_3' name='cbIntervention_3' className='add-only' value='0' />Medication access (medications that can be used for overdose or poisoning)</td>
                        <td className='w-375'><input type='checkbox' id='cbIntervention_4' name='cbIntervention_4' className='add-only' value='1' /> Access to other methods indicated by the individual</td>
                    </tr>
                </table>
                <table>


                    <tr>
                        <td className='w-750'><span className='eleHeader'> Reviewed ways to reduce access to lethal means to include:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbIntervention_1' name='cbIntervention_1' className='add-only' value='0' /> Lock up abuse-prone medications such as prescription painkillers, anxiety medications, amphetamines, sedatives, and tranquilizers.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbIntervention_2' name='cbIntervention_2' className='add-only' value='1' /> Store firearms away from the home</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbIntervention_3' name='cbIntervention_3' className='add-only' value='0' />Secure firearm storage inside the home (disassembling guns and locking). The person at risk should not have the keys, know where the keys are kept, or know the combination to the storage unit. </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbIntervention_4' name='cbIntervention_4' className='add-only' value='1' />Dispose of all unused medications, store only small bottles of the low toxicity pills the client/family routinely uses (aspirin, decongestants, and vitamins).</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbworse_6' name='cbworse_6' className='add-only' value='1' /> In high-risk situations involving opioid use, keep at least 2 doses of Narcan nasal spray, which is a highly effective rescue drug that lay people can administer. Narcan can immediately reduce the effects of an opioid overdose. </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbworse_5' name='cbworse_5' className='add-only' value='0' /> Other:
                            <input id='txtOther' name='txtOther' type='text' className='add-only' />

                        </td>
                    </tr>
                </table>

                {/* <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Name, Printed </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent Name, printed </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Staff signature (with credentials) </td>
                        <td className='small w-250'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Staff Name, printed (with credentials) </td>
                    </tr>
                </table> */}
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Clinician Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Parent Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr> 
                </table>





            </div>
        </form>

    )
}